import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StateNotifyService } from '../../../common/state/service/state-notify.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token;
  
  constructor(private http: HttpClient, private notifyService: StateNotifyService) { 
    this.token = environment.jwtToken;
  }

  requireVerificationCode(username: string, password: string, code: string): Observable<boolean> {
    return this.http.post<any>(environment.apiRoot + '/auth/vcode', {username, password, code})
      .pipe(
        map(response => {
          return true;
        }),
        catchError(error => {
          return of(false);
        })
      );
  }
  
  login(username: string, password: string, code: string): Observable<boolean> {
    localStorage.removeItem(this.token);
    return this.http.post<any>(environment.apiRoot + '/auth/login', {username, password, code})
      .pipe(
        map(response => {
          localStorage.setItem(this.token, response.token);
          this.notifyService.updateLoginState(true);
          return true;
        }),
        catchError(error => {
          console.log(error);
          this.logout();
          return of(false);
        })
      );
  }

  logout(): void {
    localStorage.removeItem(this.token);
    this.notifyService.updateLoginState(false);
  }

  get isAuthenticated() {
    let isAuth = false;
    const token = localStorage.getItem(this.token);
    if (token) {
      isAuth = true;
    }
    return isAuth;
  }

}
